import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { FlashService } from '../services/flash.service';


@Injectable({
  providedIn: 'root'
})
export class UserService {

    constructor(private http: HttpClient, private location: Location, private flashService: FlashService) {
    }

    GetOneLoginData(userId: string, onePlatformURL:string): Promise<any> {
        return this.http.get(`${onePlatformURL}/api/v2/tenant/product/user/${userId}`).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    };

    GetLoginMetadata(metadata: any): Promise<any> {
        return this.http.get('/api/MetaData/' + metadata).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    };

    GetUserDetails(): Promise<any>  {
        var self = this;
        return this.http.get('/api/Home/UserDetails').toPromise().then(self.handleSuccess, self.handleUserDeatilsError.bind(this));
    }

    GetLoginData(): Promise<any>  {
        var self = this;
        return this.http.get('/api/Account/Login/Preference').toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    Login(userCredentials): Promise<any>  {
        var self = this;
        return this.http.post('/api/Account/Login', userCredentials).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    Logout(): Promise<any>  {
        var self = this;
        return this.http.get('/api/Account/Logout').toPromise().then(self.handleSuccess, self.handleUserDeatilsError.bind(this));
    }

    GetCayuseLogoutURL(): Promise<any>   {
        var self = this;
        return this.http.get('/api/cayuse/logout-url').toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    GetCayuseRedirectURL(): Promise<any>   {
        var self = this;
        return this.http.get('api/cayuse/redirect-url').toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    SwitchRole(data): Promise<any>  {
        var self = this;
        return this.http.post('/api/Home/SwitchRole/', data).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    SwitchGroup(data): Promise<any>  {
        var self = this;
        return this.http.post('/api/Home/SwitchGroup/', data).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    SwitchSite(data): Promise<any>  {
        var self = this;
        return this.http.post('/api/Home/SwitchSite/', data).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    GetUserCredentialsStatus(): Promise<any>  {
        var self = this;
        return this.http.get('/api/Home/UserCredentialsStatus').toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    handleUserDeatilsError() {
        this.location.go('login');
        return { success: false };
    }

    handleSuccess(res) {
        return { success: true, data: res };
    }

    handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false, data: res };
    }

}
